import styled from 'styled-components/macro';
import { theme } from './theme';

export const PageContainer = styled.div`
  max-width: 96.5rem;
  margin: 0 auto;
  padding: 0rem 2rem;
  @media screen and (min-width: ${theme.breakpoints.medium}px) {
    padding: 0rem 3rem;
  }
  @media screen and (min-width: ${theme.breakpoints.large}px) {
    padding: 0;
  }
`;

// Aligné sur bazarchic-front-nextjs (feature/BZCBACK-866) : gouttière légère,
// pas de contrainte de largeur. Utilisé pour cadrer les sections du footer.
export const PageFullWidth = styled.div`
  max-width: 100%;
  margin: 0 auto;
  padding: 0rem 1rem;
  position: relative;
  @media screen and (min-width: ${theme.breakpoints.medium}px) {
    padding: 0rem 1.6rem;
  }
`;

// Aligné sur bazarchic-front-nextjs (feature/BZCBACK-866) PageHomeContainer.
export const PageHomeContainer = styled.div`
  max-width: 1301px;
  margin: 0 auto;
  padding: 0rem 1rem;
  position: relative;
  @media screen and (min-width: ${theme.breakpoints.medium}px) {
    padding: 0rem 2.2rem;
  }
  @media screen and (min-width: ${theme.breakpoints.large}px) {
    padding: 0;
  }
`;
